import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from 'src/hooks';

// Redux
import { setEditTherapistDetailView } from 'src/redux/slices/therapy.slice';

// Components
import TherapyAdditionalInfo from 'src/components/cards/admin/therapy/AdditionlInfo';

// Services
import {
  getTherapistDetailUseCase,
  TherapistMeUseCase,
  uploadCurrentTherapistPictureUseCase,
  uploadTherapyPictureUseCase,
} from 'src/services/therapy/useCases';

const EditTherapyAdditionalInfo = () => {
  const params = useParams<{ therapistId: string }>();
  const TherapistDetail = useAppSelector((state) => state.therapy.TherapistDetail);
  const editTherapistDetailView = useAppSelector((state) => state.therapy.editTherapistDetailView);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const currentRole = useAppSelector((state) => state.auth.role);

  const handleSuccess = async (values: { profilePicture: string; certificates: [] }) => {
    const formData = new FormData();
    formData.append('profilePicture', values.profilePicture);
    if (values.profilePicture) {
      if (currentRole === 'admin') {
        await dispatch(
          uploadTherapyPictureUseCase({
            therapistId: params.therapistId,
            profilePicture: formData,
          }),
        );
      } else if (currentRole === 'therapist')
        await dispatch(uploadCurrentTherapistPictureUseCase({ profilePicture: formData }));
    }
    dispatch(setEditTherapistDetailView('finish'));
  };
  useEffect(() => {
    if (editTherapistDetailView === 'finish') {
      if (currentRole === 'admin') {
        navigate('/admin/therapy');
      } else {
        navigate('/therapist/profile');
      }
    }
  }, [currentRole, editTherapistDetailView, navigate]);

  useEffect(() => {
    if (params.therapistId) {
      if (currentRole === 'admin') {
        dispatch(getTherapistDetailUseCase(params.therapistId));
      } else dispatch(TherapistMeUseCase());
    }
  }, [currentRole, dispatch, params.therapistId]);

  return (
    <TherapyAdditionalInfo onSuccess={handleSuccess} data={TherapistDetail} isEditing={true} />
  );
};

export default EditTherapyAdditionalInfo;
